import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initChannel } from "./lib/channel";

// Mark the document with its channel (and banner it) before anything renders.
initChannel();
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode><App /></React.StrictMode>
);
